import { render, staticRenderFns } from "./m-cookie-notification.vue?vue&type=template&id=bc81fa68&scoped=true&"
import script from "./m-cookie-notification.vue?vue&type=script&lang=js&"
export * from "./m-cookie-notification.vue?vue&type=script&lang=js&"
import style0 from "./m-cookie-notification.vue?vue&type=style&index=0&id=bc81fa68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc81fa68",
  null
  
)

export default component.exports